import React, { useEffect } from "react";
import { useSetting } from "store/settings";
import { handleSuccessMessages } from "store/auth";
import { Field, Form, Formik } from "formik";
import { CheckBox, Loading, Select } from "components/form";

const Banks = (props) => {
  const {
    dispatch,
    getSetting,
    submitSetting,
    gateways,
    loading,
  } = useSetting();
  const key = "gateways";

  useEffect(() => {
    dispatch(getSetting(key));
  }, []);

  if (loading) {
    return (
      <div className="box p-5 flex justify-center">
        <Loading />
      </div>
    );
  }
  return (
    <>
      <Formik
        initialValues={
          {
            USD_default_gateway: "paypal",
            IRR_default_gateway: "mellat",
            ...gateways,
          } || {}
        }
        onSubmit={async (values, { setSubmitting }) => {
          await dispatch(
            submitSetting({ value: values, key }, () =>
              handleSuccessMessages("ویرایش اطلاعات انجام شد")
            )
          );
          setSubmitting(false);
        }}
        enableReinitialize
      >
        {({ isSubmitting, dirty }) => (
          <Form>
            <div className="box rounded p-3">
              <h3> درگاه های بانکی ریالی</h3>
              <hr className="my-2" />
              <div className="">
                <div className="intro-x grid grid-cols-6 gap-4">
                  <Field label="بانک ملت" name="mellat" component={CheckBox} />
                  <Field label="بانک سامان" name="saman" component={CheckBox} />
                  <Field
                    label="بانک پاسارگاد"
                    name="pasargad"
                    component={CheckBox}
                  />
                  <Field
                    label="زرین پال"
                    name="zarinpal"
                    component={CheckBox}
                  />
                  <Field
                    label="دایرکت دبیت"
                    name="directdibet"
                    component={CheckBox}
                  />

                  <Field
                    label="درگاه پیش فرض ریالی"
                    name="IRR_default_gateway"
                    component={Select}
                    options={[
                      { label: "ملت", value: "mellat" },
                      { label: "سامان", value: "saman" },
                      { label: "پاسارگاد", value: "pasargad" },
                      { label: "زرین پال", value: "zarinpal" },
                    ]}
                  />
                </div>
              </div>
              <h3> درگاه های بانکی دلاری</h3>
              <hr className="my-2" />
              <div className="">
                <Field label="پی پال" name="paypal" component={CheckBox} />
                <Field label="google pay" name="gpay" component={CheckBox} />
                <Field label="پرداخت درون برنامه ای(اندروید)" name="inappandroid" component={CheckBox} />
                <Field label="پرداخت درون برنامه ای(ios)" name="inappios" component={CheckBox} />
                <Field
                  label="درگاه پیش فرض دلاری"
                  name="USD_default_gateway"
                  component={Select}
                  options={[{ label: "پی پال", value: "paypal" },{ label: "google pay", value: "gpay" }]}
                />
              </div>
              <button
                className=" mt-4 btn btn-primary w-20"
                type=" submit"
                disabled={!!(isSubmitting || !dirty)}
              >
                {isSubmitting ? <Loading /> : " ذخیره"}
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default Banks;
